export default __webpack_public_path__ + "static/automotive7-0a8022241d0fa6f5f586d4d8bb4a4cce.jpg";